import React from 'react';
import PropTypes from 'prop-types';
import {
  Typography,
  Divider,
  Box,
} from '@mui/material';
import {CutCopyPasteTextField} from '../CommonComponents/CustomInputs';

import { useTranslation } from "react-i18next";

export default function AdditionalInfo({formData,setFormData,readOnly}){
  const {t} = useTranslation();

  const handleValueChange =(e)=>{
    setFormData({
      ...formData,
      additionalComments: e.target.value
    });
  };

  return (
    <>
      <Typography component="h2" variant="h6" sx={{mb: 3}}>
        {t("requestForm.additionalInformation.title")}
      </Typography>
      <Typography component="p" variant="body1" sx={{mb: 3}}>
        {t("requestForm.additionalInformation.text")}
      </Typography>
      <Divider sx={{mb: 3}} />
      <Box sx={{mb: 3}}>
      <CutCopyPasteTextField
        id="additionalComments"
        name="additionalComments"
        margin="dense"
        label={t("requestForm.additionalInformation.title")}
        multiline
        minRows="3"
        variant="outlined"
        fullWidth
        onBlur={handleValueChange}
        defaultValue={formData.additionalComments}
        inputProps={{readOnly: readOnly}}
      />
      </Box>
    </>
  );
}
AdditionalInfo.propTypes={
  formData: PropTypes.object.isRequired,
  setFormData: PropTypes.func.isRequired,
  readOnly: PropTypes.bool.isRequired
};